import React from 'react';
import {NavLink} from 'react-router';
import {ReactComponent as Person} from '../../assets/icons/profile.svg';
import {ReactComponent as LogoutIcon} from '../../assets/icons/logout.svg';
import profileRoutes from '../../statics/PrivateRoutes';
import Panel from './Panel';
import {useUser} from '../../Providers/UserInfo';

const linkClass = ({isActive}, collapsed) =>
    [
        'rest-panel-nav__link',
        isActive ? 'rest-panel-nav__link--active' : '',
        collapsed ? 'rest-panel-nav__link--collapsed' : '',
    ].join(' ');

export default function PrivateNavLinks({collapsed = false, onNavigate, showPanel = true}) {
    const {logout} = useUser();

    const handleNav = () => {
        onNavigate?.();
    };

    return (
        <nav className="rest-panel-nav">
            {profileRoutes.map((route, idx) => (
                <NavLink
                    key={idx}
                    to={route.path}
                    onClick={handleNav}
                    className={(state) => linkClass(state, collapsed)}
                >
                    <span className="rest-panel-nav__icon">{route.icon}</span>
                    {!collapsed && <span className="rest-panel-nav__label">{route.label}</span>}
                </NavLink>
            ))}

            <div className="rest-panel-nav__divider"/>

            <NavLink
                to="/profile"
                onClick={handleNav}
                className={(state) => linkClass(state, collapsed)}
            >
                <span className="rest-panel-nav__icon"><Person/></span>
                {!collapsed && <span className="rest-panel-nav__label">پروفایل</span>}
            </NavLink>

            <button
                type="button"
                onClick={() => {
                    handleNav();
                    logout();
                }}
                className="rest-panel-nav__link rest-panel-nav__link--logout"
            >
                <span className="rest-panel-nav__icon rest-panel-nav__icon--logout">
                    <LogoutIcon className="fill-Secondary-950"/>
                </span>
                {!collapsed && <span className="rest-panel-nav__label">خروج از حساب کاربری</span>}
            </button>

            {showPanel && (
                <>
                    <div className="rest-panel-nav__divider"/>
                    <div className={collapsed ? 'rest-panel-nav__panel--collapsed' : 'rest-panel-nav__panel'}>
                        <Panel open={!collapsed}/>
                    </div>
                </>
            )}
        </nav>
    );
}
